import {
  INITIAL_STATE_BOX,
  INITIAL_STATE_ACTIVITIES,
  INITIAL_STATE_TRAVEL_UY,
} from 'constants/initialState';

/**
 * Converts legacy breadcrumb URLs to modern currentFilters format
 * @param {string} legacyUrl - Legacy URL like "/regalos/?card=0&filters={\"boxCategory\":\"Aventura\"}"
 * @returns {string} Modern URL with currentFilters format
 */
export function convertLegacyBreadcrumbUrl(legacyUrl) {
  try {
    // Parse the URL
    const url = new URL(legacyUrl, window.location.origin);
    const searchParams = new URLSearchParams(url.search);
    
    // Check if it has legacy filters
    const legacyFilters = searchParams.get('filters');
    const cardType = parseInt(searchParams.get('card') || '0');
    
    if (!legacyFilters) {
      // No legacy filters, return as is
      return legacyUrl;
    }
    
    // Parse legacy filters
    const parsedLegacyFilters = JSON.parse(legacyFilters);
    
    // Extract category name
    let categoryName = null;
    if (parsedLegacyFilters.boxCategory) {
      categoryName = parsedLegacyFilters.boxCategory;
    } else if (parsedLegacyFilters.activityCategory) {
      categoryName = parsedLegacyFilters.activityCategory;
    }
    
    if (!categoryName) {
      // No category found, return as is
      return legacyUrl;
    }
    
    // Generate modern currentFilters using the same logic as AllGiftsMenu.vue
    const filters = [
      { ...INITIAL_STATE_BOX }, // BOX
      { ...INITIAL_STATE_ACTIVITIES }, // ACTIVITY
      { ...INITIAL_STATE_TRAVEL_UY }, // TRAVEL_UY
    ];

    if (categoryName) {
      if (cardType === 0) {
        filters[0].category_name = [categoryName];
      } else if (cardType === 1) {
        filters[1].category_name = [categoryName];
      }
    }
    
    // Build new URL
    const newSearchParams = new URLSearchParams();
    newSearchParams.set('card', cardType.toString());
    newSearchParams.set('currentFilters', JSON.stringify(filters));
    
    // Copy other parameters (except filters)
    for (const [key, value] of searchParams.entries()) {
      if (key !== 'filters' && key !== 'card' && key !== 'currentFilters') {
        newSearchParams.set(key, value);
      }
    }
    
    return `${url.pathname}?${newSearchParams.toString()}`;
    
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error converting legacy breadcrumb URL:', error);
    // Return original URL if conversion fails
    return legacyUrl;
  }
}

/**
 * Converts a breadcrumb path array, updating legacy URLs to modern format
 * @param {Array} breadcrumbPath - Array of breadcrumb objects with url and name
 * @returns {Array} Updated breadcrumb path with modern URLs
 */
export function convertBreadcrumbPath(breadcrumbPath) {
  if (!Array.isArray(breadcrumbPath)) {
    return breadcrumbPath;
  }
  
  return breadcrumbPath.map(crumb => {
    if (crumb.url && typeof crumb.url === 'string') {
      return {
        ...crumb,
        url: convertLegacyBreadcrumbUrl(crumb.url),
      };
    }
    return crumb;
  });
}
